export const AWSActionTypes = {
    GET_AWS_KEYS: "GET_AWS_KEYS",
    GET_AWS_KEYS_FULFILLED: "GET_AWS_KEYS_FULFILLED",
  };
  